import { render } from "./HeaderContacts.vue?vue&type=template&id=c54dae0e&scoped=true"
const script = {}

import "./HeaderContacts.vue?vue&type=style&index=0&id=c54dae0e&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54dae0e"]])

export default __exports__